import { StyledModal } from '@app/components/modal/Modal';
import useUserActions from '@app/hooks/users/useUserActions';
import type { Client } from '@app/services/api.types';
import type { ModalProps } from 'antd';
import { ClientForm } from './ClientForm';

export type UserAddModalProps = ModalProps & {
    title?: string;
    data?: Client;
};

export const ClientAddModal = ({ title = 'Add New Client', data, ...props }: UserAddModalProps) => {
    const { addUser } = useUserActions();

    return (
        <StyledModal title={title} destroyOnHidden {...props} footer={null}>
            <ClientForm
                data={data}
                isEdit={false}
                onCancel={props.onCancel}
                confirmLoading={addUser.isPending}
                onSubmit={(values, reset) => {
                    const { brand_ids, channel_ids, location_ids, ...rest } = values;
                    const payload = {
                        ...rest,
                        ...(brand_ids?.length ? { brand_ids } : {}),
                        ...(channel_ids?.length ? { channel_ids } : {}),
                        ...(location_ids?.length ? { location_ids } : {}),
                    };
                    addUser.mutate(payload, {
                        onSuccess: () => {
                            reset();

                            if (props?.onOk) {
                                props.onOk(
                                    undefined as unknown as React.MouseEvent<HTMLButtonElement>
                                );
                            }
                        },
                    });
                }}
            />
        </StyledModal>
    );
};
